<template>
  <modal-layout :openModal="openModal">
      <div class="bg-white rounded-lg w-2/3 relative">
        <spinner :loading="courseLoading" />
        <div class="flex flex-col items-start p-4">
          <div class="flex items-center w-full">
            <div class="text-gray-900 font-bold text-lg">
              {{ courseDetails.title || 'Course name' }}
            </div>
            <!-- close modal icon  -->
            <div
              class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer"
              @click="closePopup"
            >
              <close-icon />
            </div>
          </div>
          <hr class="w-full my-3 h-full" />
          <div class="overflow-y-scroll w-full px-5" style="max-height: 70vh">
            <form id="basic" @submit.prevent="updateCourse">
              <div class="grid grid-cols-2 items-center mt-5">
                <div>
                  <div class="text-3xl font-bold inline-block">
                    Edit {{ Type !== typeConsants.SEGMENT ? "Product" : "Segment"}}
                  </div>
                  <br />
                  <div class="text-xl inline-block text-gray-600">
                    Enter {{ Type !== typeConsants.SEGMENT ? "product" : "segment"}} details
                  </div>
                </div>
                <div v-if="Type !== typeConsants.SEGMENT" class="text-right">
                  <input

                    type="checkbox"
                    v-model="publish"
                    class="toggle align-middle"
                  />
                  <div class="text-lg font-bold inline-block ml-3">Publish</div>
                  <button
                    :disabled="
                      (Type !== typeConsants.SEGMENT || title.trim() === '') &&
                      (description.trim() === '' ||
                        title.trim() === '' ||
                        (scheduled && !Frequency) ||
                        (Deliver === 'TWEET'
                          ? !scheduled || !Frequency
                          : !linear && !Frequency))
                    "
                    type="submit"
                    class="btn btn-primary text-lg ml-3"
                  >
                    Save
                  </button>
                </div>
              </div>

              <div class="mt-4">
                <input
                  type="text"
                  placeholder="Title (required)"
                  class="input input-bordered w-full mb-2"
                  required
                  name="title"
                  v-model="title"
                  @input="onEdit"
                />
                <textarea
                  class="textarea h-64 textarea-bordered w-full mb-1"
                  placeholder="Description (required)"
                  :required="Type !== typeConsants.SEGMENT ? true : false"
                  name="description"
                  v-model="description"
                  @input="onEdit"
                />
                <!-- only course section  start-->
                <section v-if="Type !== typeConsants.SEGMENT">
                <div
                  v-if="userInfo.user && user.role === 'SUPERADMIN'"
                  class="form-control py-3 w-full"
                >
                  <div class="text-xl inline-block">Course Type:</div>

                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="radio"
                      value="mail"
                      v-model="Type"
                      @input="onEdit"
                      class="
                        h-4
                        w-4
                        text-primaryColor
                        border-indigo-900 border-2
                      "
                    />
                    <span class="label-text text-lg ml-3">Mail</span>
                  </label>

                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="radio"
                      value="twitter"
                      v-model="Type"
                      @input="onEdit"
                      class="
                        h-4
                        w-4
                        text-primaryColor
                        border-indigo-900 border-2
                      "
                    />
                    <span class="label-text text-lg ml-3">Twitter</span>
                  </label>
                </div>
                <div
                  v-if="user && user.role === 'SUPERADMIN' && Type !== typeConsants.SEGMENT"
                  class="form-control"
                >
                  <div class="text-xl inline-block">Deliver course on:</div>
                  <label
                    v-if="Type === 'twitter'"
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="radio"
                      value="TWEET"
                      v-model="Deliver"
                      class="
                        h-4
                        w-4
                        text-primaryColor
                        border-indigo-900 border-2
                      "
                    />
                    <span class="label-text text-lg ml-3">via Tweets</span>
                  </label>

                  <label
                    v-if="Type === 'twitter'"
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="radio"
                      value="DM"
                      v-model="Deliver"
                      class="
                        h-4
                        w-4
                        text-primaryColor
                        border-indigo-900 border-2
                      "
                    />
                    <span class="label-text text-lg ml-3">via DM</span>
                  </label>

                  <label
                    v-if="Type === 'twitter'"
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="radio"
                      value="SITE"
                      v-model="Deliver"
                      class="
                        h-4
                        w-4
                        text-primaryColor
                        border-indigo-900 border-2
                      "
                    />
                    <span class="label-text text-lg ml-3"
                      >Site with Twitter Engagement</span
                    >
                  </label>

                  <label
                    v-if="Type === 'twitter'"
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="radio"
                      value="SITE-NOTE"
                      v-model="Deliver"
                      class="
                        h-4
                        w-4
                        text-primaryColor
                        border-indigo-900 border-2
                      "
                    />
                    <span class="label-text text-lg ml-3"
                      >Site with Twitter Notification</span
                    >
                  </label>

                  <label
                    v-if="Type === 'mail'"
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="radio"
                      value="MAIL"
                      v-model="Deliver"
                      class="
                        h-4
                        w-4
                        text-primaryColor
                        border-indigo-900 border-2
                      "
                    />
                    <span class="label-text text-lg ml-3"
                      >Site with Mail Engagement</span
                    >
                  </label>

                  <label
                    v-if="Type === 'mail'"
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="radio"
                      value="MAIL-NOTE"
                      v-model="Deliver"
                      class="
                        h-4
                        w-4
                        text-primaryColor
                        border-indigo-900 border-2
                      "
                    />
                    <span class="label-text text-lg ml-3"
                      >Site with Mail Notification</span
                    >
                  </label>
                </div>
                <div
                  class="form-control"
                  v-if="user && user.role === 'SUPERADMIN'"
                >
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="checked"
                      class="checkbox checkbox-primary"
                      v-model="scheduled"
                      @input="onEdit"
                    />
                    <span class="label-text text-lg ml-3">Scheduled</span>
                    <input
                      v-if="scheduled"
                      type="datetime-local"
                      placeholder="Date-Time"
                      class="input input-bordered ml-5"
                      required
                      name="publishDateTime"
                      v-model="publishDateTime"
                      @input="onEdit"
                    />
                  </label>
                </div>
                <div
                  v-if="scheduled && isNaN(new Date(publishDateTime).getTime())"
                  class="text-red-500"
                >
                  Please enter valid date time
                </div>
                <div
                  class="form-control"
                  v-if="user && user.role === 'SUPERADMIN'"
                >
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="checked"
                      class="checkbox checkbox-primary"
                      v-model="linear"
                      @input="onEdit"
                    />
                    <span class="label-text text-lg ml-3">Sequential</span>
                  </label>
                </div>
                <div class="form-control">
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="checked"
                      class="checkbox checkbox-primary"
                      v-model="Frequency"
                    />
                    <span class="label-text text-lg ml-3">Frequency</span>
                    <select
                      v-model="frequency"
                      v-if="Frequency"
                      class="select select-bordered ml-5"
                      @input="onEdit"
                      required
                    >
                      <option disabled="disabled" value="">
                        Choose frequency
                      </option>
                      <option value="DAILY">Daily</option>
                      <option value="WEEKLY">Weekly</option>
                    </select>
                  </label>
                </div>
                <div class="form-control">
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="Limitstudent"
                      class="checkbox checkbox-primary"
                      v-model="Limitstudent"
                      @input="onEdit"
                    />
                    <span class="label-text text-lg ml-3">Limit Students</span>
                  </label>
                </div>
                <input
                  type="number"
                  v-if="Limitstudent"
                  placeholder="Max. Students (required)"
                  class="input input-bordered w-95/100 ml-5/100 mt-2 mb-2"
                  required
                  name="maxStudents"
                  min="1"
                  oninput="validity.valid||(value='');"
                  v-model="maxStudents"
                  @input="onEdit"
                />
                <div
                  class="form-control"
                  v-if="user && user.role === 'SUPERADMIN'"
                >
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="checked"
                      class="checkbox checkbox-primary"
                      v-model="Threadseries"
                      @input="onEdit"
                    />
                    <span class="label-text text-lg ml-3"
                      >Create a thread series</span
                    >
                  </label>
                </div>
                <div class="form-control">
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="checked"
                      class="checkbox checkbox-primary"
                      v-model="sharingtips"
                      @input="onEdit"
                    />
                    <span class="label-text text-lg ml-3"
                      >Require Registration for sharing tips</span
                    >
                  </label>
                </div>
                <div class="form-control">
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="checked"
                      class="checkbox checkbox-primary"
                      v-model="AllowsubmissionviaDM"
                      @input="onEdit"
                    />
                    <span class="label-text text-lg ml-3"
                      >Allow assignment submission via DM
                    </span>
                    <span class="label-text text-md ml-3 mt-1"
                      >( warn: conversations might be flagged as assignment
                      submissions )</span
                    >
                  </label>
                </div>
                <div
                  class="form-control"
                  v-if="user && user.role === 'SUPERADMIN'"
                >
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="Charge"
                      class="checkbox checkbox-primary"
                      v-model="Charge"
                      @input="
                        onEdit();
                        price = '';
                      "
                    />
                    <span class="label-text text-lg ml-3"
                      >Charge for the course</span
                    >
                  </label>
                </div>
                <input
                  type="number"
                  v-if="
                    Charge &&
                    user &&
                    user.role === 'SUPERADMIN'
                  "
                  placeholder="Price (required)"
                  class="input input-bordered w-95/100 ml-5/100 mt-2 mb-2"
                  required
                  min="1"
                  oninput="validity.valid||(value='');"
                  name="price"
                  v-model="price"
                  @input="onEdit"
                />
                <div
                  class="form-control w-95/100 ml-5/100"
                  v-if="
                    Charge &&
                    user &&
                    user.role === 'SUPERADMIN'
                  "
                >
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="PPP"
                      class="checkbox checkbox-primary"
                      v-model="PPP"
                      @input="onEdit"
                    />
                    <span class="label-text text-lg ml-3"
                      >Use Purchasing Power Parity</span
                    >
                  </label>
                </div>
                <div
                  class="form-control"
                  v-if="user && user.role === 'SUPERADMIN'"
                >
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="checked"
                      class="checkbox checkbox-primary"
                      v-model="Enablehashtag"
                      @input="onEdit"
                    />
                    <span class="label-text text-lg ml-3"
                      >Enable hashtag submission (premium)</span
                    >
                  </label>
                </div>
                <div
                  class="form-control"
                  v-if="user && user.role === 'SUPERADMIN'"
                >
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="checked"
                      class="checkbox checkbox-primary"
                      v-model="showBackground"
                      @input="onEdit"
                    />
                    <span class="label-text text-lg ml-3"
                      >Background ( does not work for all settings )</span
                    >
                  </label>
                </div>
                <div
                  class="form-control"
                  v-if="user && user.role === 'SUPERADMIN'"
                >
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="checked"
                      class="checkbox checkbox-primary"
                      v-model="showCheck"
                      @input="onEdit"
                    />
                    <span class="label-text text-lg ml-3"
                      >Check ( does not work for all settings )</span
                    >
                  </label>
                </div>
                <div
                  class="form-control"
                  v-if="user && user.role === 'SUPERADMIN'"
                >
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="checked"
                      class="checkbox checkbox-primary"
                      v-model="showFeedback"
                      @input="onEdit"
                    />
                    <span class="label-text text-lg ml-3"
                      >Feedback ( does not work for all settings )</span
                    >
                  </label>
                </div>
                <div
                  class="form-control"
                  v-if="user && user.role === 'SUPERADMIN'"
                >
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="checked"
                      class="checkbox checkbox-primary"
                      v-model="showParticipate"
                      @input="onEdit"
                    />
                    <span class="label-text text-lg ml-3"
                      >Participate ( does not work for all settings )</span
                    >
                  </label>
                </div>
                <div
                  class="form-control"
                  v-if="user && user.role === 'SUPERADMIN'"
                >
                  <label
                    class="cursor-pointer label justify-start"
                    style="width: fit-content"
                  >
                    <input
                      type="checkbox"
                      checked="checked"
                      class="checkbox checkbox-primary"
                      v-model="showTakeaway"
                      @input="onEdit"
                    />
                    <span class="label-text text-lg ml-3"
                      >Takeaway ( does not work for all settings )</span
                    >
                  </label>
                </div>
                <div class="flex">
                  <div class="flex-grow">
                    <input
                      disabled
                      type="text"
                      placeholder="Image"
                      class="input input-bordered w-full mb-2"
                      name="img"
                      v-model="img"
                      @input="onEdit"
                    />
                  </div>
                  <div class="flex-none ml-3">
                    <input
                      ref="selectedFile"
                      class="
                        w-full
                        mt-3
                        text-indigo-700
                        outline-none
                        bg-gray-100
                      "
                      type="file"
                      name="selectedFile"
                      style="display: none"
                      accept="image/jpeg, image/png"
                      @change="onImageUpload"
                      @input="onEdit"
                    />
                    <button
                      type="button"
                      class="btn btn-outline"
                      @click="$refs.selectedFile.click()"
                    >
                      Select...
                    </button>
                  </div>
                </div>
                <img width="500" class="pl-2" :src="imagePreview" alt="" />
                </section>
                 <!-- only course section  end-->
              </div>
            </form>
          </div>
          <hr class="w-full my-3" />
          <div class="ml-auto">
            <button
              class="btn btn-primary"
              :disabled="
                (Type !== typeConsants.SEGMENT || title.trim() === '') &&
                (description.trim() === '' ||
                  title.trim() === '' ||
                  (scheduled && !Frequency) ||
                  (Deliver === 'TWEET'
                    ? !scheduled || !Frequency
                    : !linear && !Frequency))
              "
              @click="updateCourse"
            >
              Save
            </button>
            <button class="btn btn-outline ml-3" @click="closePopup">
              Cancel
            </button>
          </div>
        </div>
      </div>
  </modal-layout>
</template>

<script>
import axios from 'axios';
import courseAPI from '@/services/course';
import closeIcon from '../icons/closeIcon.vue';
import spinner from '@/components/spinner.vue';
import courseType from '@/utils/Constants/courseType.constants';
import utils from '@/services/utils';
import ModalLayout from '../../layouts/ModalLayout.vue';

export default {
  name: 'EditCourseModal',
  components: { closeIcon, spinner, ModalLayout },
  props: ['courseId', 'openModal', 'closePopup', 'getDetailsAgain'],
  data() {
    return {
      courseLoading: false,
      userInfo: {
        user: {
          role: 'SUPERADMIN',
        },
      },
      updateLoading: false,
      title: '',
      description: '',
      price: '',
      maxStudents: '',
      linear: false,
      Type: 'twitter',
      scheduled: false,
      Charge: false,
      PPP: false,
      publishDateTime: '',
      frequency: '',
      Frequency: false,
      publish: true,
      image: null,
      Deliver: 'TWEET',
      imagePreview: '',
      img: '',
      courseData: null,
      feedPopup: false,
      autosave: null,
      sharingtips: false,
      Enablehashtag: false,
      Threadseries: false,
      showBackground: false,
      showCheck: false,
      showFeedback: false,
      showParticipate: false,
      showTakeaway: false,
      AllowsubmissionviaDM: false,
      nextpage: null,
      ischange: false,
      Limitstudent: false,
      typeConsants: courseType,
    };
  },
  computed: {
    courseDetails: {
      get() {
        return this.$store.state.courses?.courseDetails;
      },
      set(newData) {
        return newData;
      },
    },
    user() {
      return this.$store.state.userDetails;
    },
  },
  async mounted() {
    await this.fetchCourse();
    if (!this.user) {
      this.$store.dispatch('getMyDetails', {});
    }
  },
  methods: {
    async fetchCourse() {
      try {
        this.courseLoading = true;
        await this.$store.dispatch('fetchCourse', this.courseId);
        this.setAllInitialValues();
        this.courseLoading = false;
      } catch (error) {
        utils.setStatusMsg(this, error?.message);
      }
    },
    onEdit() {
      console.log('edit');
      this.ischange = true;
      clearTimeout(this.autosave);
      //   this.autosave = setTimeout(() => this.autosaveCourse(), 10000);
    },
    onImageUpload(e) {
      if (e.target.files.length > 0) {
        [this.image] = e.target.files;
        const data = URL.createObjectURL(this.image);
        this.imagePreview = data;
        console.log(data, 'data');
      }
    },
    async updateCourse() {
      try {
        this.courseLoading = true;
        let secureUrl = '';
        if (this.image !== null) {
          secureUrl = await this.uploadImage();
        }
        const publishDateTime = new Date(this.publishDateTime);
        let payload = {
          title: this.title,
          description: this.description,
          price: this.price === '' ? 0 : this.price,
          maxStudents: this.maxStudents,
          linear: this.linear,
          scheduled: this.scheduled,
          publishDateTime: this.scheduled
            ? publishDateTime.getTime()
            : new Date().getTime(),
          frequency: this.Frequency ? this.frequency : '',
          Frequency: this.Frequency,
          publish: this.publish,
          currency: 'USD',
          purchaseParityEnabled: this.PPP,
          medium: this.Deliver,
          setStudentLimit: this.Limitstudent,
          sharingtips: this.sharingtips,
          Enablehashtag: this.Enablehashtag,
          Threadseries: this.Threadseries,
          showBackground: this.showBackground,
          showCheck: this.showCheck,
          showFeedback: this.showFeedback,
          showParticipate: this.showParticipate,
          showTakeaway: this.showTakeaway,
          AllowsubmissionviaDM: this.AllowsubmissionviaDM,
          type: this.Type,
        };
        if (secureUrl !== '') {
          payload = { ...payload, image: secureUrl };
        }
        await courseAPI.updateCourse(this.courseId, payload, this.user?.userId);
        this.ischange = false;
        // close modal
        await this.getDetailsAgain();
        this.courseLoading = false;
        this.closePopup();
      } catch (error) {
        console.log('update course error', error);
        utils.setStatusMsg(
          this,
          error?.response?.data?.message || 'Something went wrong',
        );
        // close modal
        this.closePopup();
        this.courseLoading = false;
      }
    },
    async uploadImage() {
      try {
        const cloudName = 'implicit';
        const formData = new FormData();
        formData.append('upload_preset', 'courses');
        formData.append('file', this.image);
        if (this.image) {
          const res = await axios.post(
            `https://api.cloudinary.com/v1_1/${cloudName}/upload`,
            formData,
            {
              transformRequest: (data, headers) => {
                // eslint-disable-next-line no-param-reassign
                delete headers.common.Authorization;
                return data;
              },
            },
          );
          if (res) return res.data.secure_url;
        }
      } catch (error) {
        console.log('upload image error', error);
      }
      return null;
    },
    setAllInitialValues() {
      this.title = this.courseDetails?.title;
      this.description = this.courseDetails?.description;
      this.price = this.courseDetails?.price;
      this.PPP = this.courseDetails?.purchaseParityEnabled;
      this.Charge = this.courseDetails?.price !== 0;
      this.maxStudents = this.courseDetails?.maxStudents;
      this.linear = this.courseDetails?.linear;
      this.scheduled = this.courseDetails?.scheduled;
      this.publish = this.courseDetails?.publish;
      this.Limitstudent = this.courseDetails?.setStudentLimit;
      this.Type = this.courseDetails?.type;
      this.sharingtips = this.courseDetails?.sharingtips;
      this.Enablehashtag = this.courseDetails?.Enablehashtag;
      this.Threadseries = this.courseDetails?.Threadseries;
      this.showBackground = this.courseDetails?.showBackground;
      this.showCheck = this.courseDetails?.showCheck;
      this.showFeedback = this.courseDetails?.showFeedback;
      this.showParticipate = this.courseDetails?.showParticipate;
      this.showTakeaway = this.courseDetails?.showTakeaway;
      this.AllowsubmissionviaDM = this.courseDetails?.AllowsubmissionviaDM;
      this.Deliver = this.courseDetails?.medium;
      const publishDateTimeISO = new Date(this.courseDetails?.publishDateTime);
      publishDateTimeISO.setMinutes(
        publishDateTimeISO.getMinutes() -
          publishDateTimeISO.getTimezoneOffset(),
      );
      this.publishDateTime = publishDateTimeISO.toISOString().slice(0, 16);
      this.frequency = this.courseDetails?.frequency;
      this.Frequency = this.courseDetails?.Frequency;
      this.imagePreview = this.courseDetails?.image;
      const imgParts = this.courseDetails?.image?.split('/');
      this.img = imgParts?.at(-1);
    },
  },
  beforeDestroy() {
    clearTimeout();
  },
};
</script>

<style></style>
